import { AppJoyride } from "@/shared/ui/AppJoyride";
import { dashboardTourSteps } from "./tourSteps";

type DashboardTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function DashboardTour({ run, onCallback }: DashboardTourProps) {
  return (
    <AppJoyride
      steps={dashboardTourSteps}
      run={run}
      onCallback={onCallback}
    />
  );
}

export { useDashboardTour } from "./useDashboardTour";
